var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 45.5,
    fill: "white",
    stroke: "#F6B119",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.2809 31.707C71.8254 31.2542 71.2092 31 70.5669 31C69.9246 31 69.3084 31.2542 68.8529 31.707L42.574 57.8675C42.1833 58.2565 41.5513 58.2558 41.1614 57.8659L27.2799 43.9844C26.835 43.504 26.2175 43.22 25.5633 43.195C24.909 43.1699 24.2716 43.4057 23.7912 43.8507C23.3108 44.2956 23.0269 44.9131 23.0018 45.5673C22.9767 46.2216 23.2126 46.859 23.6575 47.3394L41.1607 64.7958C41.551 65.1851 42.1828 65.1851 42.5731 64.7957L72.2809 35.1592C72.5087 34.9332 72.6896 34.6643 72.813 34.3681C72.9365 34.0718 73 33.754 73 33.4331C73 33.1122 72.9365 32.7944 72.813 32.4981C72.6896 32.2019 72.5087 31.933 72.2809 31.707Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessDelete);
export default __webpack_public_path__ + "static/media/SuccessDelete.fec302c4361b646f85b1faabc5faa972.svg";
export { ForwardRef as ReactComponent };